var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip-group',_vm._b({staticClass:"text-upper",class:{
		'event-types-group-centered': _vm.centered !== false,
	},attrs:{"value":_vm.value},on:{"change":_vm.onInput}},'v-chip-group',_vm.$attrs,false),_vm._l((_vm.eventTypes),function(eventType,index){return _c('BAChip',{key:index,staticClass:"my-auto",class:{
			'white--text': _vm.filterIsActive(eventType.name),
			'inactive-chip': !_vm.filterIsActive(eventType.name)
		},attrs:{"disabled":_vm.disabled,"value":eventType.name,"small":_vm.small,"color":_vm.getEventChipColor(eventType)}},[_vm._v(" "+_vm._s(eventType.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }